export default {
  consulars: {
    consularRemoved: 'مشاور حذف شد',
    consularUpdated: 'مشاور به روز رسانی شد',
    consularAdded: 'مشاور افزوده شد',
    consulars: 'مشاورها',
    consular: 'مشاور',
  }
}
